import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterNodeData, QaSimpleFilter } from "./qaTypes";

export const samQaSliceName = "samQa";

export interface SamQaState {
  basicFilter: QaSimpleFilter;
  dictionaryFilter: QaSimpleFilter;
}

const initialState: SamQaState = {
  basicFilter: {},
  dictionaryFilter: {},
};

const samSlice = createSlice({
  name: samQaSliceName,
  initialState,
  reducers: {
    setQaBasicProjectStructureFilter(state: SamQaState, action: PayloadAction<FilterNodeData[]>) {
      state.basicFilter = { projectStructure: action.payload };
    },
    setQaBasicTemplateFilter(state: SamQaState, action: PayloadAction<FilterNodeData[]>) {
      state.basicFilter = { template: action.payload };
    },
    resetQaBasicFilter(state: SamQaState) {
      state.basicFilter = {};
    },
    setQaDictionaryProjectStructureFilter(state: SamQaState, action: PayloadAction<FilterNodeData[]>) {
      state.dictionaryFilter = { projectStructure: action.payload };
    },
    setQaDictionaryTemplateFilter(state: SamQaState, action: PayloadAction<FilterNodeData[]>) {
      state.dictionaryFilter = { template: action.payload };
    },
    resetQaDictionaryFilter(state: SamQaState) {
      state.dictionaryFilter = {};
    },
  },
});

export interface SamQaRootState {
  [samQaSliceName]: SamQaState;
}

export const selectSamQa = (state: SamQaRootState) => state[samQaSliceName];
export const selectSamQaBasicFilter = (state: SamQaRootState) => selectSamQa(state).basicFilter;
export const selectSamQaDictionaryFilter = (state: SamQaRootState) => selectSamQa(state).dictionaryFilter;

export const {
  setQaBasicProjectStructureFilter, setQaBasicTemplateFilter, resetQaBasicFilter,
  setQaDictionaryProjectStructureFilter, setQaDictionaryTemplateFilter, resetQaDictionaryFilter,
} = samSlice.actions;
export const samQaReducer = samSlice.reducer;
